export default __webpack_public_path__ + "static/media/IMG_0011_2_11zon.e04eff95.jpg";